'use client';

import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

import { type Match } from '@common/clients/api';
import { ComponentErrorBoundary } from '@common/molecules/ComponentErrorBoundary';
import { useContextData } from '@common/useContextData';
import { formatOddsGroupsUrls } from '@common/utils/betting';
import { fetchMatch } from '@web/handlers/fetchMatch';

const DynamicHighlightedMatch = dynamic(
    () => import('@web/organisms/HighlightedMatch').then((mod) => mod.HighlightedMatch),
    { loading: () => null },
);

export const MatchBlockWrapper = ({ matchID, match }: { matchID?: string; match?: Match }) => {
    const [currentMatch, setMatch] = useState<Match | undefined>(match);
    const contextData = useContextData();
    const { modulesBySection } = useContextData();
    const articleMatches = modulesBySection?.articleMatches?.[0];

    useEffect(() => {
        if (match?.id || matchID) {
            void fetchMatch(contextData, match?.id || matchID || '', articleMatches).then((match) => {
                if (match) {
                    setMatch(match);
                }
            });
        }
    }, [matchID, contextData, match?.id, articleMatches]);

    if (!currentMatch) return null;

    if (currentMatch.odds && articleMatches) {
        currentMatch.odds = formatOddsGroupsUrls(articleMatches, currentMatch.odds);
    }

    return (
        <ComponentErrorBoundary title={'boundaryError.highlightedMatch'}>
            <DynamicHighlightedMatch match={currentMatch} showOdds={true} isCompactMatchblock />
        </ComponentErrorBoundary>
    );
};
